import { Component, DestroyRef, inject } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { ApiService } from "../../../../../../../shared/src";
import { SearchComponent } from "../../../../components/search/search.component";
import { BalanceDisplayComponent } from "../balance-display/balance-display.component";
import { NavService } from "../../../../../../../shared/src/lib/services/nav.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CoreService } from "../../../../../../../shared/src/lib/services/core.service";
import { DomainService } from "../../../../../../../shared/src/lib/services/domain.service";
import { BreakpointObserver, BreakpointState } from "@angular/cdk/layout";
import { environment } from "../../../../../../../shared/src/environments/environment";
import { SentryFeedbackComponent } from "../../../../components/sentry-feedback/sentry-feedback.component";
import { MarketService } from "../../../../../../../shared/src/lib/services/market.service";
import { HeaderNavigationComponent } from "../header-navigation/header-navigation.component";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
  imports: [RouterLink, SearchComponent, BalanceDisplayComponent, TranslateModule, HeaderNavigationComponent, SentryFeedbackComponent],
})
export class HeaderComponent {
  apiService = inject(ApiService);
  navService = inject(NavService);
  translate = inject(TranslateService);
  coreService = inject(CoreService);
  domainService = inject(DomainService);
  marketService = inject(MarketService);
  breakpointObserver = inject(BreakpointObserver);
  router = inject(Router);
  showMobileBalance = false;
  user: any = null;
  protected readonly environment = environment;
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.breakpointObserver.observe(["(max-width: 900px)"]).subscribe((state: BreakpointState) => {
      this.showMobileBalance = state.matches;
    });
    const app = this.apiService.getUserToken();
    this.user = app.user;
    // console.log(this.apiService.getUserToken());
  }

  get showFeedbackButton() {
    return this.environment.SENTRY_ENABLED;
  }
}
